
import { defineComponent } from 'vue'
import { constants } from '@/constants'
import { setI18nLanguage } from '@/i18n'
import { LanguagesType } from '@/types'
import AsahiTypography from '@/components/library/Typography.vue'
import AsahiButton from '@/components/library/AsahiButton.vue'
import AsahiLogoNew from '@/components/library/assets/AsahiLogoNew.vue'
import AsahiLanguageSelector from '@/components/library/AsahiLanguageSelector.vue'

export default defineComponent({
  name: 'LoginPage',
  components: {
    AsahiLanguageSelector,
    AsahiTypography,
    AsahiButton,
    AsahiLogoNew
  },
  data: () => ({
    isAgeConfirmed: true,
    activeLanguage: (localStorage.getItem('lang')) as LanguagesType
  }),

  computed: {
    isFullLoaded () {
      return this.$store.state.auth.isFullLoaded && this.$store.state.auth.isLanguageLoaded
    },

    user () {
      return this.$store.state.auth.user
    },

    languages () {
      if (this.user.country === 'CZE' || window.location.hostname.includes('.cz')) {
        return ['cs', 'en']
      }

      if (this.user.country === 'SVK' || window.location.hostname.includes('.sk')) {
        return ['sk', 'en']
      }

      return ['cs', 'en', this.activeLanguage].filter((x, index, self) => x !== 'null' && x != null && self.indexOf(x) === index)
    }
  },

  watch: {
    isFullLoaded: {
      handler (value) {
        if (value === true) {
          const impUsr = this.$route.query.imp_usr
          if (impUsr) {
            sessionStorage.setItem('imp_usr', impUsr.toString())
          }
          this.$navigate(localStorage.getItem('redirectpath') ?? '/')
          localStorage.setItem('redirectpath', '')
        }
      },
      immediate: true
    }
  },

  mounted () {
    if (localStorage?.getItem('lang') === 'null') {
      this.activeLanguage = this.languages[0] as LanguagesType
    } else {
      this.activeLanguage = (localStorage?.getItem('lang') || this.languages[0]) as LanguagesType
    }
    setI18nLanguage(this.activeLanguage)

    this.displayLoginScreenSet()
  },

  methods: {
    changeLanguage (langCode: LanguagesType) {
      this.activeLanguage = langCode
      this.displayLoginScreenSet()
    },

    displayLoginScreenSet () {
      const el = document.getElementById('login-container')
      if (el) {
        el.innerHTML = ''
      }

      this.$nextTick(() => {
        window.gigya.accounts.showScreenSet({
          screenSet: constants.gigyaConfig.screenSet,
          startScreen: constants.gigyaConfig.startScreen,
          containerID: 'login-container',
          sessionExpiration: '20000',
          lang: this.activeLanguage
        })
      })
    }
  }
})
